var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "credits-management" } }, [
    _c("div", { staticClass: "flex" }, [
      _c(
        "div",
        {
          staticClass: "sticky left-0 z-30 flex items-center gap-2 px-6 py-3",
          style: { width: "calc(100vw - 0.5rem)" }
        },
        [
          _c("BlInputSearch", {
            staticClass: "w-80",
            attrs: { input: _vm.searchInput },
            on: { changed: _vm.onInputSearch }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "w-40" },
            [
              _c("BlInputFilter", {
                attrs: { input: _vm.filterInput },
                on: { changed: _vm.onChangeFilter }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("BlSort", {
            staticClass: "w-60",
            attrs: { options: _vm.sortOptions, defaultValue: _vm.defaultSort },
            on: {
              change: function($event) {
                return _vm.onChangeSort($event)
              }
            },
            model: {
              value: _vm.sortInput,
              callback: function($$v) {
                _vm.sortInput = $$v
              },
              expression: "sortInput"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _vm.pageLoading
      ? _c("div", { staticClass: "grid h-128 place-items-center" }, [
          _c("div", { staticClass: "blum-loader" })
        ])
      : !_vm.creditsManagement.length
      ? _c(
          "div",
          { staticClass: "flex flex-col items-center justify-center h-128" },
          [
            _c("BlTextBody1", {
              staticClass: "text-center",
              attrs: {
                text:
                  "Credit management will appear once you add a new client.."
              }
            })
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "mb-8" },
          [
            _c(
              "div",
              {
                staticClass:
                  "sticky z-20 flex items-center flex-grow rounded-t top-36 bg-slate-300",
                attrs: { id: "credits-management-header" }
              },
              [
                _c(
                  "div",
                  { staticClass: "sticky left-0 z-10 flex pl-6 bg-slate-100" },
                  [
                    _c(
                      "BlTooltip",
                      {
                        staticClass:
                          "flex items-center flex-shrink-0 w-56 h-12 px-4 border-t border-l border-r rounded-tl bg-slate-300 border-slate-400",
                        scopedSlots: _vm._u([
                          {
                            key: "tooltip",
                            fn: function() {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex flex-col gap-1 text-center w-44"
                                  },
                                  [
                                    _c("b", [_vm._v("Name")]),
                                    _vm._v(" "),
                                    _c("div", [_vm._v("Client name")])
                                  ]
                                )
                              ]
                            },
                            proxy: true
                          }
                        ])
                      },
                      [
                        _vm._v(" "),
                        _c("BlTextSubtitle3", {
                          staticClass: "truncate",
                          attrs: { text: "Name" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "BlTooltip",
                  {
                    staticClass:
                      "flex items-center flex-shrink-0 w-40 h-12 px-4 border-t bg-slate-300 border-slate-400",
                    scopedSlots: _vm._u([
                      {
                        key: "tooltip",
                        fn: function() {
                          return [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex flex-col gap-1 text-center w-44"
                              },
                              [
                                _c("b", [_vm._v("Client status")]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v("The current status of the client.")
                                ])
                              ]
                            )
                          ]
                        },
                        proxy: true
                      }
                    ])
                  },
                  [
                    _vm._v(" "),
                    _c("BlTextSubtitle3", {
                      staticClass: "truncate",
                      attrs: { text: "Client status" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "BlTooltip",
                  {
                    staticClass:
                      "flex items-center flex-shrink-0 w-40 h-12 px-4 border-t bg-slate-300 border-slate-400",
                    scopedSlots: _vm._u([
                      {
                        key: "tooltip",
                        fn: function() {
                          return [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex flex-col gap-1 text-center w-44"
                              },
                              [
                                _c("b", [_vm._v("Branch")]),
                                _vm._v(" "),
                                _c("div", [_vm._v("The branch of the client.")])
                              ]
                            )
                          ]
                        },
                        proxy: true
                      }
                    ])
                  },
                  [
                    _vm._v(" "),
                    _c("BlTextSubtitle3", {
                      staticClass: "truncate",
                      attrs: { text: "Branches" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "BlTooltip",
                  {
                    staticClass:
                      "flex items-center flex-shrink-0 w-40 h-12 px-4 border-t bg-slate-300 border-slate-400",
                    scopedSlots: _vm._u([
                      {
                        key: "tooltip",
                        fn: function() {
                          return [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex flex-col gap-1 text-center w-44"
                              },
                              [
                                _c("b", [_vm._v("Available credits")]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "\n              The total number of available credits that have not yet expired.\n            "
                                  )
                                ])
                              ]
                            )
                          ]
                        },
                        proxy: true
                      }
                    ])
                  },
                  [
                    _vm._v(" "),
                    _c("BlTextSubtitle3", {
                      staticClass: "truncate",
                      attrs: { text: "Available credits" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "BlTooltip",
                  {
                    staticClass:
                      "flex items-center flex-shrink-0 w-40 h-12 px-4 border-t bg-slate-300 border-slate-400",
                    scopedSlots: _vm._u([
                      {
                        key: "tooltip",
                        fn: function() {
                          return [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex flex-col gap-1 text-center w-44"
                              },
                              [
                                _c("b", [_vm._v("Reserved credits")]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "\n              The total number of credits reserved for appointments but not\n              deducted until the appointments are concluded.\n            "
                                  )
                                ])
                              ]
                            )
                          ]
                        },
                        proxy: true
                      }
                    ])
                  },
                  [
                    _vm._v(" "),
                    _c("BlTextSubtitle3", {
                      staticClass: "truncate",
                      attrs: { text: "Reserved credits" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "BlTooltip",
                  {
                    staticClass:
                      "flex items-center flex-shrink-0 w-40 h-12 px-4 border-t bg-slate-300 border-slate-400",
                    scopedSlots: _vm._u([
                      {
                        key: "tooltip",
                        fn: function() {
                          return [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex flex-col gap-1 text-center w-44"
                              },
                              [
                                _c("b", [_vm._v("Unused credits")]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "\n              The total number of credits not yet reserved for any\n              appointments.\n            "
                                  )
                                ])
                              ]
                            )
                          ]
                        },
                        proxy: true
                      }
                    ])
                  },
                  [
                    _vm._v(" "),
                    _c("BlTextSubtitle3", {
                      staticClass: "truncate",
                      attrs: { text: "Unused credits" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "BlTooltip",
                  {
                    staticClass:
                      "flex items-center flex-shrink-0 w-40 h-12 px-4 border-t bg-slate-300 border-slate-400",
                    scopedSlots: _vm._u([
                      {
                        key: "tooltip",
                        fn: function() {
                          return [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex flex-col gap-1 text-center w-44"
                              },
                              [
                                _c("b", [_vm._v("Scheduled sessions")]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "\n              The total number of sessions that have been scheduled from\n              appointments.\n            "
                                  )
                                ])
                              ]
                            )
                          ]
                        },
                        proxy: true
                      }
                    ])
                  },
                  [
                    _vm._v(" "),
                    _c("BlTextSubtitle3", {
                      staticClass: "truncate",
                      attrs: { text: "Scheduled sessions" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "BlTooltip",
                  {
                    staticClass:
                      "flex items-center flex-shrink-0 w-40 h-12 px-4 border-t bg-slate-300 border-slate-400",
                    scopedSlots: _vm._u([
                      {
                        key: "tooltip",
                        fn: function() {
                          return [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex flex-col gap-1 text-center w-44"
                              },
                              [
                                _c("b", [_vm._v("Expiration date")]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "\n              The earliest expiration date of the available credits.\n            "
                                  )
                                ])
                              ]
                            )
                          ]
                        },
                        proxy: true
                      }
                    ])
                  },
                  [
                    _vm._v(" "),
                    _c("BlTextSubtitle3", {
                      staticClass: "truncate",
                      attrs: { text: "Expiration date" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "BlTooltip",
                  {
                    staticClass:
                      "flex items-center flex-shrink-0 w-40 h-12 px-4 border-t bg-slate-300 border-slate-400",
                    scopedSlots: _vm._u([
                      {
                        key: "tooltip",
                        fn: function() {
                          return [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex flex-col gap-1 text-center w-44"
                              },
                              [
                                _c("b", [_vm._v("Reschedule credits")]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "\n              The total number of available reschedule credits that have not\n              yet expired.\n            "
                                  )
                                ])
                              ]
                            )
                          ]
                        },
                        proxy: true
                      }
                    ])
                  },
                  [
                    _vm._v(" "),
                    _c("BlTextSubtitle3", {
                      staticClass: "truncate",
                      attrs: { text: "Reschedule credits" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "BlTooltip",
                  {
                    staticClass:
                      "flex items-center flex-shrink-0 w-40 h-12 px-4 border-t bg-slate-300 border-slate-400",
                    scopedSlots: _vm._u([
                      {
                        key: "tooltip",
                        fn: function() {
                          return [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex flex-col gap-1 text-center w-44"
                              },
                              [
                                _c("b", [_vm._v("Balance")]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "\n              The total amount of available credits in the local currency.\n            "
                                  )
                                ])
                              ]
                            )
                          ]
                        },
                        proxy: true
                      }
                    ])
                  },
                  [
                    _vm._v(" "),
                    _c("BlTextSubtitle3", { attrs: { text: "Balance" } })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "sticky right-0 z-10 flex flex-grow pr-6 bg-slate-100"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex items-center flex-grow flex-shrink-0 w-20 h-12 px-4 border-t border-r rounded-tr bg-slate-300 border-slate-400"
                      },
                      [_c("BlTextSubtitle3", { attrs: { text: "" } })],
                      1
                    )
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm._l(_vm.creditsManagement, function(client, idx) {
              return _c("CreditItem", {
                key: client.id,
                attrs: {
                  client: client,
                  isLast: idx + 1 === _vm.creditsManagement.length
                }
              })
            })
          ],
          2
        ),
    _vm._v(" "),
    _vm.totalCreditsManagement > 25
      ? _c(
          "div",
          { staticClass: "flex mb-36" },
          [
            _c("BlInputPagination", {
              staticClass: "sticky left-6",
              style: { width: "calc(100vw - 3rem - 0.5rem)" },
              attrs: {
                page: _vm.page,
                perPage: _vm.perPage,
                total: _vm.totalCreditsManagement
              },
              on: {
                changed: _vm.changePage,
                "changed-per-page": _vm.changePerPage
              }
            })
          ],
          1
        )
      : _c("div", { staticClass: "mb-46" })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a7434f0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a7434f0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/finance/CreditsManagement.vue
// module id = null
// module chunks = 